import * as React from "react";
import { observer, Provider } from "mobx-react";
import { DocumentList } from "../Document/DocumentList";
import { DocumentPreviews } from "../Document/DocumentPreviews";
import { Area } from "../General/Area";
import { AreaBody } from "../General/AreaBody"
import { Toolbar } from "../General/Toolbar";
import { CloseButton } from "../Buttons/CloseButton";
import { ViewList } from "../Buttons/ViewList";
import { ViewCard } from "../Buttons/ViewCard";
import { Urls } from "../Urls";
import { AppStore } from "../Stores/AppStore";
import { Strings } from "../Stores/StringsStore";
import { RecentFilesUIStore } from "../Stores/RecentFilesUIStore";
import { PreviewStore } from "../Stores/PreviewStore";

@observer
export class RecentFiles extends React.Component<{}, {}> {

	store: RecentFilesUIStore = new RecentFilesUIStore();
	previewStore: PreviewStore = new PreviewStore("recentFiles");

	componentDidMount() {
		AppStore.setTitle(Strings.homepage.recentFilesTitle);
		this.previewStore.loadSettings();
		this.store.triggerSearch();
	}

	componentDidUpdate() {
		AppStore.setTitle(Strings.homepage.recentFilesTitle);
		this.store.triggerSearch();
	}

	handleCancel = () => {
		AppStore.keepOnPage(Urls.home);
	}

	render() {
		return <Provider store={this.store}>
			<Area>
				<AreaBody>
					<Toolbar>
						<span className="buttongroup is--buttongroup-right">
							<CloseButton onClick={this.handleCancel} testId="closeButton" />
						</span>
						<span className="buttongroup is--buttongroup-right">
							<ViewList store={this.previewStore} />
							<ViewCard store={this.previewStore} />
						</span>
					</Toolbar>
					<div className="area-grid__body-content">
						<div className="content-main recent-filelist-container">
							<h1>{Strings.homepage.recentFilesTitle}</h1>
							{!this.previewStore.showPreviews ? <DocumentList showValidities={true} isSelected={() => false} /> : <DocumentPreviews />}
						</div>
					</div>
				</AreaBody>
			</Area>
		</Provider>;
	}
}